/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const WifiSync = [
  ["path", { d: "M11.965 10.105v4L13.5 12.5a5 5 0 0 1 8 1.5" }],
  ["path", { d: "M11.965 14.105h4" }],
  ["path", { d: "M17.965 18.105h4L20.43 19.71a5 5 0 0 1-8-1.5" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
  ["path", { d: "M21.965 22.105v-4" }],
  ["path", { d: "M5 12.86a10 10 0 0 1 3-2.032" }],
  ["path", { d: "M8.5 16.429h.01" }]
];

export { WifiSync as default };
//# sourceMappingURL=wifi-sync.js.map
